import React, { useEffect } from "react";

/**
 * The heading block every page starts with.
 *
 * Router-free on purpose: Merchants.test.js renders <Merchants /> with no MemoryRouter, so
 * a useLocation() or a <Link> in here would take that whole suite down.
 *
 * It owns document.title as well as the <h1>, which is what keeps the browser tab and the
 * heading from drifting apart the way they had. Being a function component rendered *by*
 * the two class pages, the effect runs in its own render, so neither of them has to be
 * converted to a function component to get it.
 *
 * `lead` is a string prop rather than children on purpose. children is an open container:
 * it accepts three paragraphs, and the pages this replaces had up to three. A string makes
 * one line the only shape that fits, and it guarantees no call site can add a second
 * heading -- four tests call bare getByRole("heading"), which throws on more than one.
 */
export function PageHeader({ title, lead, titleId }) {
  useEffect(() => {
    document.title = `${title} · TowPay`;
  }, [title]);

  return (
    <div className="border-bottom pb-3 mb-4">
      <h1 id={titleId} className="h3 mb-0">
        {title}
      </h1>
      {lead ? <p className="text-secondary mb-0 mt-2">{lead}</p> : null}
    </div>
  );
}

export default PageHeader;
